import { deleteDB, openDB } from "idb";

const DATABASE_NAME = "main";
const DATABASE_VERSION = 3;

let connection;

const openConnection = () =>
  openDB(DATABASE_NAME, DATABASE_VERSION, {
    upgrade: (database, oldVersion, newVersion, transaction) => {
      if (oldVersion < 1) {
        const incomingMessagesStore = database.createObjectStore(
          "incomingMessages",
          {
            keyPath: "id",
          }
        );

        incomingMessagesStore.createIndex("createdAt", "createdAt");

        database.createObjectStore("logs", {
          keyPath: "id",
        });
      }

      if (oldVersion < 2) {
        const incomingMessagesStore =
          transaction.objectStore("incomingMessages");

        incomingMessagesStore.createIndex("timestamp", "timestamp");
      }

      if (oldVersion < 3) {
        transaction.objectStore("logs").createIndex("timestamp", "timestamp");
      }
    },

    blocking: () => {
      window.console.warn(
        "[idb] closing connection so a newer database version can upgrade"
      );

      const closing = connection;

      connection = undefined;

      closing?.then((database) => database.close()).catch(() => {});
    },

    blocked: (currentVersion, blockedVersion) => {
      window.console.warn(
        "[idb] open blocked: an older connection is still open",
        { blockedVersion, currentVersion }
      );
    },

    terminated: () => {
      connection = undefined;
    },
  });

const open = async () => {
  try {
    return await openConnection();
  } catch (error) {
    if (error?.name === "VersionError") {
      window.console.warn(
        "[idb] existing database is newer than this build expects; recreating",
        error.message
      );

      await deleteDB(DATABASE_NAME, {
        blocked: () => {
          window.console.warn(
            "[idb] delete blocked by an open connection; waiting for it to close"
          );
        },
      });

      return openConnection();
    }

    throw error;
  }
};

export const idb = async () => {
  if (connection) {
    return connection;
  }

  connection = open();

  try {
    return await connection;
  } catch (error) {
    connection = undefined;

    throw error;
  }
};
